import React, { useState, useEffect, useRef } from "react";
import "./MultiSelect.css";

export default function MultiSelect({
  id,
  options = [],
  value = [],
  onChange = () => {},
  openDropdownId,
  setOpenDropdownId,
  placeholder = "Select...",
  className = "",
}) {
  const open = openDropdownId === id;
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdownId(null);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setOpenDropdownId]);
  

  const masterCheckRef = useRef(null);

  const toggleOpen = () => {
    setOpenDropdownId(open ? null : id);
  };

  const handleSelect = (val) => {
    const newValues = value.includes(val)
      ? value.filter((v) => v !== val)
      : [...value, val];
    onChange(newValues);
  };

  const filteredOptions = (options || []).filter((opt) =>
  (opt.label || "").toLowerCase().includes(search.toLowerCase())
);
  // const allValues = options.map((o) => o.value);
  const visibleValues = filteredOptions.map((o) => o.value);

  // const isAllChecked = value.length === allValues.length;
  // const isPartial = value.length > 0 && !isAllChecked;
  const isAllChecked =
  visibleValues.length > 0 &&
  visibleValues.every((v) => value.includes(v));

const isPartial =
  visibleValues.some((v) => value.includes(v)) && !isAllChecked;


  useEffect(() => {
    if (masterCheckRef.current) {
      masterCheckRef.current.indeterminate = isPartial;
    }
  }, [isPartial]);

  // const handleMasterCheck = (e) => {
  //   if (e.target.checked) onChange(visibleValues);
  //   else onChange([]);
  // };
  const handleMasterCheck = (e) => {
    if (e.target.checked) {
      // ADD searched items, keep old ones
      const newValues = Array.from(
        new Set([...value, ...visibleValues])
      );
      onChange(newValues);
    } else {
      // REMOVE only searched items
      const newValues = value.filter(
        (v) => !visibleValues.includes(v)
      );
      onChange(newValues);
    }
  };
  

  return (
    <div className={`multi-select multipleSelectMainDiv${className ? ` ${className}` : ""}`}>
      
      {/* FIXED onClick */}
      <div className="multi-select-box"  onClick={ !open && toggleOpen}>
        {value.length > 0 ? (
          <div className="multi-select-tags">
            {value.map((v) => {
              const option = options.find((o) => o.value === v);
              return (
                <span key={v} className="multi-tag" title={option ? option.label : v}>
                  {option ? option.label : v}
                </span>
              );
            })}
          </div>
        ) : (
          <span></span>
        )}
      </div>

      {open && (
        <div className="multi-select-dropdown" ref={dropdownRef}>
          {options.length === 0 ? (
            <div className="no-options">No options found</div>
          ) : (
            <>
              <div className="search-box">
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search..."
                />
              </div>

              <div className="check-all-row ms-2">
                <input
                  type="checkbox"
                  ref={masterCheckRef}
                  checked={isAllChecked}
                  onChange={handleMasterCheck}
                />
                <label className="ms-2">Select All</label>
              </div>

              {filteredOptions.map((opt) => (
                <div
                  key={opt.value}
                  className={`multi-item ${
                    value.includes(opt.value) ? "selected" : ""
                  }`}
                  onClick={() => handleSelect(opt.value)}
                >
                  <input
                    type="checkbox"
                    checked={value.includes(opt.value)}
                    readOnly
                  />
                  <span>{opt.label}</span>
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
}
